export const apostilleInitialValues = {
  cdLinhaApostila: '',
  cdLinha: '',
  cdSolicitacao: '',
  nuApostilaFmt: '',
  nuProcesso: '',
  nuProcessoSei: '',
  dtEmissao: new Date(),
  dtInicioValidade: null,
  deBaseLegal: '',
  deAditamento: '',
  boAtivo: '',
  dePublicacao: '',
  deObservacao:'',
  cdUsuarioResponsavel: '',
  linha: {},
};
